import {ReactNode} from 'react'
import s from '../style.module.scss'
import clsx from 'clsx'

interface Props {
  logo: ReactNode
  hideText: boolean
}

const LogoAndText = ({logo, hideText}: Props) => {
  return (
    <div className={clsx(s.logo_text)}>
      {logo}
      <span className={clsx(s.tc_divider, {hidden: hideText})}>|</span>
      <span className={clsx('mr-5', {hidden: hideText})}>Terms, Privacy, & other links</span>
    </div>
  )
}

export default LogoAndText
